import { put, call, all, takeEvery } from 'redux-saga/effects'
import { store as reduxStore } from 'index'
import {
  list as extensionsList,
  changeExtensionStatus as extensionChangeStatus,
  removeExtension,
} from 'services/extensions'
import _ from 'lodash'
import actions from './actions'

export function* EXTENSIONS_LIST(activeApp = []) {
  yield put({
    type: actions.SET_STATE,
    payload: { areExtensionsLoading: true },
  })

  const appData = activeApp.data || reduxStore.getState().apps.active

  try {
    const allExtensions = yield call(extensionsList, appData)

    if (allExtensions && allExtensions.data) {
      const installedExtensions = _.filter(allExtensions.data, ext => ext.enabled)
      yield put({
        type: actions.SET_STATE,
        payload: {
          extensionsAllList: allExtensions.data,
          extensionsInstalledList: installedExtensions,
          areExtensionsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          extensionsAllList: [],
          extensionsInstalledList: [],
          areExtensionsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { areExtensionsLoading: false },
    })
    window.triggerNotification('Failed to fetch extensions', 'error')
  }
}

export function* ENTER_EXTENSION_TEXT({ payload }) {
  const { searchText, clearText } = payload
  if (clearText) {
    yield put({
      type: actions.SET_STATE,
      payload: { extensionSearchText: '' },
    })
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: { extensionSearchText: searchText },
    })
  }
}

export function* CHANGE_EXTENSION_STATUS({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { areExtensionsLoading: true },
  })

  const activeApp = reduxStore.getState().apps.active

  try {
    const success = yield call(extensionChangeStatus, payload.id, payload.status, activeApp)

    if (success && success.data) {
      yield put({
        type: actions.EXTENSIONS_LIST,
        data: activeApp,
      })
      window.triggerNotification('Extension status updated', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: { areExtensionsLoading: false },
      })
      if (success && success.error && success.error.message) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Failed to update extension status', 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { areExtensionsLoading: false },
    })
    window.triggerNotification('Failed to update extension status', 'error')
  }
}

export function* ENABLE_DISABLE_EXTENSION({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { areExtensionsLoading: true },
  })

  const activeApp = reduxStore.getState().apps.active

  try {
    let success
    if (payload.action === 'remove') {
      success = yield call(removeExtension, payload.id, activeApp)
    } else {
      success = yield call(extensionChangeStatus, payload.id, payload.status, activeApp)
    }

    if (success && success.data) {
      yield put({
        type: actions.EXTENSIONS_LIST,
        data: activeApp,
      })
      const msg = payload.action === 'remove' ? 'Extension removed' : 'Extension updated'
      window.triggerNotification(msg, 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: { areExtensionsLoading: false },
      })
      if (success && success.error && success.error.message) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Failed to update extension', 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { areExtensionsLoading: false },
    })
    window.triggerNotification('Failed to update extension', 'error')
  }
}

export default function* extensionsSaga() {
  yield all([
    takeEvery(actions.EXTENSIONS_LIST, EXTENSIONS_LIST),
    takeEvery(actions.ENTER_EXTENSION_TEXT, ENTER_EXTENSION_TEXT),
    takeEvery(actions.CHANGE_EXTENSION_STATUS, CHANGE_EXTENSION_STATUS),
    takeEvery(actions.ENABLE_DISABLE_EXTENSION, ENABLE_DISABLE_EXTENSION),
  ])
}
